import { PageModel, PanelModel } from '@psyomics/surveyjs-core';

import { Survey, SurveySet } from '../../survey-types';

const getSurveyByRespondentType = (surveySet: SurveySet, selectedRespondentType?: string) =>
  surveySet.find(({ respondentType }) => respondentType === selectedRespondentType);

const getPageByName = (survey: Survey, pageName: string) => {
  return survey?.model.getPageByName(pageName);
};

const getPanelByName = (survey: Survey, panelName: string) => {
  return survey?.model.getPanelByName(panelName);
};

const getQuestionByName = (survey: Survey, questionName: string) => survey?.model?.getQuestionByName(questionName);

const getAllQuestions = (survey: Survey, page?: PageModel, panel?: PanelModel) => {
  const includeNested = true;
  const visibleOnly = false;
  const includeDesignTime = false;
  if (panel) {
    return panel.getQuestions(includeNested);
  }

  return page
    ? page.getQuestions(includeNested)
    : survey?.model.getAllQuestions(visibleOnly, includeDesignTime, includeNested);
};

export { getAllQuestions, getPageByName, getPanelByName, getQuestionByName, getSurveyByRespondentType };
